"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableWithScroll = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _table = require("../table");

var _Table = require("./Table.style");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const TableWithScroll = ({
  width,
  tableProps
}) => {
  const {
    borderRadius,
    data,
    showPagination,
    totalRecords,
    perPage,
    handlePagination,
    hideCaption
  } = tableProps;
  const [page, setPageChange] = (0, _react.useState)(0);
  const [caption, setCaption] = (0, _react.useState)('');

  const onPageChange = id => {
    setPageChange(id);
    handlePagination(id);
  };

  return /*#__PURE__*/_react.default.createElement(_Table.StyledWrapper, {
    width: width,
    caption: caption,
    hideCaption: hideCaption
  }, /*#__PURE__*/_react.default.createElement(_Table.StyledContainer, {
    width: width,
    borderRadius: borderRadius
  }, /*#__PURE__*/_react.default.createElement(_table.Table, _extends({}, tableProps, {
    changedPageNumber: page,
    borderRadius: "0px",
    showPagination: false,
    tableCaption: caption
  }))), showPagination && /*#__PURE__*/_react.default.createElement(_Table.StyleFooter, {
    borderRadius: borderRadius
  }, /*#__PURE__*/_react.default.createElement(_table.Pagination, {
    showPagination: showPagination,
    totalRecords: data && data.length && totalRecords,
    perPage: perPage,
    setCaption: setCaption,
    handlePagination: onPageChange
  })));
};

exports.TableWithScroll = TableWithScroll;
TableWithScroll.defaultProps = {
  width: '100%'
};
TableWithScroll.propTypes = {
  width: _propTypes.default.string,
  tableProps: _propTypes.default.object
};